<template>
  <div id="extra-component-form-validation-demo">
    <!-- <h1>Test POI</h1> -->
    <Header :pageTitle="pageTitleLocal" :breadcrumb="breadcrumbLocal"></Header>
    <List></List>
  </div>
</template>

<script>
import Header from '../../layouts/components/HeaderWBread/Header.vue'
import List from './POIList.vue'
import * as REPO from '../../repository/index'

export default {
  components: {
    List,
    Header,
  },
  data() {
    return {
      id: '',
      pageTitle: 'POI',
      breadcrumb: [
        { title: 'Home', url: '/' },
        { title: 'Master Data' },
        { title: 'Point of Interest (POI)' },
        { title: 'POI Detail', active: true },
      ],
      catpoi: [],
    }
  },
  computed: {
    pageTitleLocal: {
      get() {
        return this.pageTitle
      },
      set(val) {
        this.$emit('update:pageTitle', val)
      },
    },
    breadcrumbLocal: {
      get() {
        return this.breadcrumb
      },
      set(val) {
        this.$emit('update:breadcrumb', val)
      },
    },
  },
  created() {
    this.id = this.$route.params.id
    this.getData()
  },
  methods: {
    getData() {
      REPO.getOneCategoryPOI(this.id)
        .then((res) => {
          this.pageTitle =
            res.data.data.catpoi_name + '(' + res.data.data.catpoi_code + ')'
          this.catpoi = res.data.data
          this.breadcrumb[3].title = this.pageTitle

          // this.$vs.loading.close('#data-list-list-view > .con-vs-loading')
          // this.getPOI()
        })
        .catch((err) => {
          //
        })
    },
  },
}
</script>
